import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ToolStatusIndicator/ToolStatusIndicator.tsx
import { useRef } from "react";
import { MdCheckCircle, MdError } from "react-icons/md";
import { formatToolName, isStreamLive } from "../../../../domain/index.mjs";
import { Spinner, Text } from "../../../primitive/index.mjs";
import { useUnfold } from "../shared/unfold.mjs";
import { ShimmerText } from "../ShimmerText/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ToolStatusIndicator({
  toolName,
  toolCallId,
  status,
  failedReason,
  onToolClick,
  sessionStatus
}) {
  const { t, i18n } = useTranslation();
  const formattedToolName = t(`tool.${toolName}.label`, { defaultValue: formatToolName(toolName) });
  const hasSuccessLabel = i18n.exists(`tool.${toolName}.success`);
  const failedText = t(`tool.${toolName}.failed`, { defaultValue: t("tool.fallback.failed") });
  const isClickable = onToolClick && toolCallId && status !== "running";
  const isRunning = status === "running" && isStreamLive(sessionStatus);
  const isInterrupted = status === "running" && !isRunning;
  const chipRef = useRef(null);
  useUnfold(chipRef, status);
  const handleClick = () => {
    if (isClickable) {
      onToolClick(toolCallId);
    }
  };
  const getStatusIcon = () => {
    switch (status) {
      case "running":
        return isRunning ? /* @__PURE__ */ jsx(Spinner, { size: "sm", "aria-hidden": true }) : /* @__PURE__ */ jsx(MdError, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--failed", "aria-hidden": true });
      case "success":
        return hasSuccessLabel ? /* @__PURE__ */ jsx(MdCheckCircle, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--success", "aria-hidden": true }) : /* @__PURE__ */ jsx(MdCheckCircle, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--success", role: "img", "aria-label": t("tool.fallback.succeeded") });
      case "failed":
        return /* @__PURE__ */ jsx(MdError, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--failed", "aria-hidden": true });
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: chipRef,
      className: `buyscout-timeline-tool${isClickable ? " clickable" : ""}`,
      onClick: handleClick,
      role: isClickable ? "button" : void 0,
      tabIndex: isClickable ? 0 : void 0,
      onKeyDown: isClickable ? (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      } : void 0,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "buyscout-timeline-tool-header", children: [
          /* @__PURE__ */ jsx(ShimmerText, { active: isRunning, children: /* @__PURE__ */ jsx(Text, { variant: "body", italic: true, as: "span", className: "buyscout-timeline-tool-name", children: formattedToolName }) }),
          getStatusIcon()
        ] }),
        status === "success" && hasSuccessLabel && /* @__PURE__ */ jsx(Text, { variant: "body", as: "div", className: "buyscout-timeline-tool-result", children: t(`tool.${toolName}.success`) }),
        status === "failed" && /* @__PURE__ */ jsx(Text, { variant: "error", as: "div", className: "buyscout-timeline-tool-error", children: failedReason || failedText }),
        isInterrupted && /* @__PURE__ */ jsx(Text, { variant: "error", as: "div", className: "buyscout-timeline-tool-error", children: t("tool.fallback.interrupted") })
      ]
    }
  );
}
export {
  ToolStatusIndicator
};
//# sourceMappingURL=ToolStatusIndicator.mjs.map